// extracted by mini-css-extract-plugin
export default {"img":"notFound_img__AdIBC","wrapper":"notFound_wrapper__X30CC","text":"notFound_text__Cgfcp","notF":"notFound_notF__pv-8Y","people":"notFound_people__d6kUz"};